export { default } from './PremisLudi';
